import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Home from './components/Home';
import Services from './components/Services';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactForm from './components/ContactForm';
import HeroSection2 from './components/HeroSection2';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactUs from './pages/ContactPage';

import PrePress from './pages/ServicesPages/PrePress';
import OffsetPrinting from './pages/ServicesPages/OffsetPrinting';
import DigitalPrinting from './pages/ServicesPages/DigitalPrinting';
import PostPress from './pages/ServicesPages/PostPress';
import Packaging from './pages/ServicesPages/Packaging';
import CatalogPrinting from './pages/ServicesPages/CatalogPrinting';
import VisitingCardPrinting from './pages/ServicesPages/CardPrinting';
import BrochurePrinting from './pages/ServicesPages/BrochurePrinting';
import BookPrinting from './pages/ServicesPages/BookPrinting';
import BoxPrinting from './pages/ServicesPages/BoxPrinting';

function App() {
  return (
    <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/services/pre-press" element={<PrePress />} />
          <Route path="/services/offset-printing" element={<OffsetPrinting />} />
          <Route path="/services/digital-printing" element={<DigitalPrinting />} />
          <Route path="/services/post-press" element={<PostPress />} />
          <Route path="/services/packaging" element={<Packaging />} />
          <Route path="/services/catalog-printing" element={<CatalogPrinting />} />
          <Route path="/services/card-printing" element={<VisitingCardPrinting />} />
          <Route path="/services/brochure-printing" element={<BrochurePrinting />} />
          <Route path="/services/catalog-printing" element={<CatalogPrinting />} />
          <Route path="/services/book-printing" element={<BookPrinting />} />
          <Route path="/services/box-printing" element={<BoxPrinting />} />


        </Routes>
    </Router>
   
  );
}

export default App;
